import { Api, Config } from './api'

export const ApiObterOcorrenciaTipo = async () => {
   const { data } = await Api.get(`/ocorrencias-tipo`, Config())

   return data
}
export const ApiRegistrarJustificativa = async (payload) => {
   const { data } = await Api.post(`/justificativas`, payload, Config())

   return data
}
export const ApiEditarJustificativa = async (id, payload) => {
   const { data } = await Api.put(`/justificativas/${id}`, payload, Config())

   return data
}
